export const installmentStatuses = {
  OPEN: 'O',
  PAID: 'P'
}
